// extracted by mini-css-extract-plugin
export var active = "X_bd";
export var arrow = "X_9";
export var button = "X_cf";
export var buttonMobile = "X_d6";
export var column = "X_dc";
export var columns = "X_db";
export var container = "X_b";
export var description = "X_dx";
export var disclaimer = "X_cz";
export var disclaimerButton = "X_d2";
export var disclaimerContainer = "X_d8";
export var disclaimerText = "X_fc";
export var fadeBottom = "X_fb";
export var fadeTop = "X_d9";
export var featureFooter = "X_d4";
export var footer = "X_cb";
export var footerMobile = "X_d5";
export var heading = "X_G";
export var highlight = "X_d3";
export var icon = "X_bq";
export var iconContainer = "X_dy";
export var left = "X_bT";
export var padding = "X_dQ";
export var popular = "X_dP";
export var prefix = "X_d1";
export var recommend = "X_dZ";
export var recommended = "X_d0";
export var right = "X_cv";
export var section = "X_d";
export var show = "X_L";
export var subHeading = "X_H";
export var suffix = "X_dM";
export var title = "X_h";
export var waveContainer = "X_d7";
export var waveOne = "X_q";
export var waveThree = "X_bZ";
export var waveTwo = "X_n";
export var waves = "X_bY";